export const UPDATE_GROUP = "UPDATE_GROUP";
export const UPDATE_GROUP_IS_LOADING = "UPDATE_GROUP_IS_LOADING";
export const UPDATE_GROUP_ERROR = "UPDATE_GROUP_ERROR";

export const ONBOARD_GROUP = "ONBOARD_GROUP";
export const ONBOARD_GROUP_IS_LOADING = "ONBOARD_GROUP_IS_LOADING";
export const ONBOARD_GROUP_ERROR = "ONBOARD_GROUP_ERROR";
